import PropTypes from 'prop-types';
import React from 'react';
import { FeedbackSteps as Steps } from './constants/feedback-constants';
import { useFeedbackFlow } from './hooks/use-feedback-flow';
import FeedbackLowScoreScreen from './low-score/feedback-low-score-screen';
import FeedbackRatingScreen from './rating/feedback-rating-screen';
import FeedbackThankYouScreen from './thank-you/feedback-thank-you-screen';

const FeedbackSteps = ({ form, locale }) => {
  const {
    step, score, isSubmitting, setScore, submitRating, submitLowScore,
  } = useFeedbackFlow({ form, locale });

  // Already submitted (or just submitted): only the acknowledgement, no form.
  if (form.feedbackSubmitted || step === Steps.THANK_YOU) {
    return <FeedbackThankYouScreen message={form.acknowledgementMessage} />;
  }
  if (step === Steps.LOW_SCORE) {
    return (
      <FeedbackLowScoreScreen
        lowScore={form.lowScore}
        buttonText={form.rating.buttonText}
        isSubmitting={isSubmitting}
        onSubmit={submitLowScore}
      />
    );
  }
  return (
    <FeedbackRatingScreen
      rating={form.rating}
      ratingStyle={form.ratingStyle}
      score={score}
      isSubmitting={isSubmitting}
      onScoreChange={setScore}
      onSubmit={submitRating}
    />
  );
};

FeedbackSteps.propTypes = {
  locale: PropTypes.string,
  form: PropTypes.shape({
    captureUrl: PropTypes.string,
    feedbackSubmitted: PropTypes.bool,
    ratingStyle: PropTypes.string,
    lowScoreThreshold: PropTypes.number,
    rating: PropTypes.shape({}),
    lowScore: PropTypes.shape({
      questions: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    acknowledgementMessage: PropTypes.string,
  }).isRequired,
};

FeedbackSteps.defaultProps = {
  locale: undefined,
};

export default FeedbackSteps;
